export * from './tags';

export enum AWSRegion {
  US_EAST_1 = 'us-east-1',
  US_EAST_2 = 'us-east-2',
  US_WEST_1 = 'us-west-1',
  US_WEST_2 = 'us-west-2',
  AP_SOUTH_1 = 'ap-south-1',
  AP_SOUTHEAST_1 = 'ap-southeast-1',
  AP_SOUTHEAST_2 = 'ap-southeast-2',
  AP_NORTHEAST_1 = 'ap-northeast-1',
  AP_NORTHEAST_2 = 'ap-northeast-2',
  AP_NORTHEAST_3 = 'ap-northeast-3',
  CA_CENTRAL_1 = 'ca-central-1',
  EU_CENTRAL_1 = 'eu-central-1',
  EU_WEST_1 = 'eu-west-1',
  EU_WEST_2 = 'eu-west-2',
  EU_WEST_3 = 'eu-west-3',
  EU_NORTH_1 = 'eu-north-1',
  SA_EAST_1 = 'sa-east-1',
}

export const RegionLabels: Record<AWSRegion, string> = {
  [AWSRegion.US_EAST_1]: 'US East (N. Virginia)',
  [AWSRegion.US_EAST_2]: 'US East (Ohio)',
  [AWSRegion.US_WEST_1]: 'US West (N. California)',
  [AWSRegion.US_WEST_2]: 'US West (Oregon)',
  [AWSRegion.AP_SOUTH_1]: 'Asia Pacific (Mumbai)',
  [AWSRegion.AP_SOUTHEAST_1]: 'Asia Pacific (Singapore)',
  [AWSRegion.AP_SOUTHEAST_2]: 'Asia Pacific (Sydney)',
  [AWSRegion.AP_NORTHEAST_1]: 'Asia Pacific (Tokyo)',
  [AWSRegion.AP_NORTHEAST_2]: 'Asia Pacific (Seoul)',
  [AWSRegion.AP_NORTHEAST_3]: 'Asia Pacific (Osaka)',
  [AWSRegion.CA_CENTRAL_1]: 'Canada (Central)',
  [AWSRegion.EU_CENTRAL_1]: 'Europe (Frankfurt)',
  [AWSRegion.EU_WEST_1]: 'Europe (Ireland)',
  [AWSRegion.EU_WEST_2]: 'Europe (London)',
  [AWSRegion.EU_WEST_3]: 'Europe (Paris)',
  [AWSRegion.EU_NORTH_1]: 'Europe (Stockholm)',
  [AWSRegion.SA_EAST_1]: 'South America (São Paulo)',
};

export const US_EAST_1 = AWSRegion.US_EAST_1;
export const US_WEST_2 = AWSRegion.US_WEST_2;
export const EU_WEST_1 = AWSRegion.EU_WEST_1;
export const AP_SOUTH_1 = AWSRegion.AP_SOUTH_1;
export const EU_WEST_2 = AWSRegion.EU_WEST_2;

// As of July 25, all VMs are initially provisioned in eu-west-1
export const DEFAULT_VM_REGION = EU_WEST_1;

export const getSupportedVMRegions = ({
  isCellInfraEnabled = false,
}: {
  isCellInfraEnabled?: boolean;
} = {}): AWSRegion[] => {
  const activeRegions = [EU_WEST_1, US_EAST_1];

  if (isCellInfraEnabled) {
    activeRegions.push(AP_SOUTH_1);
  }
  return activeRegions;
};
